module.exports = __webpack_public_path__ + "img/Character_Yoimiya_Thumb.8edd4d60.png";